<template>
  <div class="list-item">
    <a href="#" @click.prevent="onSelect">
      <div class="list-item__avatar chatting">
      <div class="avatar_status">
        <img :src="member.avatar" alt="">
        <div :class="[ isOnline() ? 'bubble_online' : 'bubble_ofline' ]">
          <span class="bubble-outer-dot">
            <span class="bubble-inner-dot"></span>
          </span>
        </div>
      </div>
      <div class="list-item__info">
        <span class="list-item__info__name">{{ member.username }}</span>
      </div>
    </div>
      <div class="chatting_sample">
        <p :style="getSeenStyle()">
          {{ lastMessage.text | sizeFilter }}
        </p>
      </div>
      <div class="list_actions chatting_time">
        <p :style="getSeenStyle()">{{ lastMessage.createdDate | timeFormat(getLocale.toLowerCase()) }}</p>
      </div>
    </a>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Vue from 'vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'chat-user',
  props: {
    id: {
      type: Number,
      required: true,
    },
    member: {
      type: Object,
      required: true,
    },
    lastMessage: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapMutations('common', [
      'toggleNeedLoad',
    ]),
    ...mapMutations('chat', [
      'setActiveConversationId',
    ]),
    ...mapMutations('users', [
      'setSelectedUser',
    ]),
    ...mapActions('chat', [
      'createConversation',
    ]),
    onSelect() {
      const { username } = this.member;
      this.setSelectedUser(username);
      this.goToChat();
    },
    goToChat() {
      this.$router.push({ name: 'chat' });
    },
    isOnline() {
      return this.getOnlineUsers.filter(user => user && user.username === this.member.username).length;
    },
    getSeenStyle() {
      return !this.lastMessage.read && this.lastMessage.authorUsername !== this.userDetails.username ? { 'font-weight': 'bold' } : {};
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('users', [
      'getOnlineUsers',
      'getSearchedUsers',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
    ]),
  },
  filters: {
    timeFormat(date, locale) {
      moment.locale(locale);
      const momentDate = moment(date);
      const differenceInDays = moment().endOf('day').diff(momentDate, 'days');
      if (differenceInDays > 1) { // before yesterday -> full date display
        return momentDate.format('DD/MM/YYYY');
      }
      if (differenceInDays === 0) { // today -> time display
        return momentDate.format('HH:mm');
      }
      return momentDate.calendar().split(' ')[0]; // 'yesterday'
    },
    sizeFilter(text) {
      if (!text) return '';
      return `${text.substring(0, 12)}${text.length > 12 ? '..' : ''}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/chat/ChatUser.vue